/*
 * Carrito lateral de ZOCCA
 * Reemplaza la app AMP Slide Cart Drawer. Ver Documents/ZOCCA/PROYECTO_CARRITO.md
 */
(function () {
  'use strict';

  var SECCION = 'cart-drawer';
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var refrescando = false;
  var ultimoAgregado = null; // sobre este producto se arma "Completa tu look"
  var enCambioDeTalla = false; // mientras se cambia una talla no se refresca a medias

  // Shopify rechaza con 422 cuando no hay inventario suficiente. Sin avisar, la clienta
  // cree que el carrito se dañó.
  function avisar(texto) {
    var panel = document.querySelector('.zc__panel');
    if (!panel) return;
    var caja = panel.querySelector('[data-zc-aviso]');
    if (!caja) {
      caja = document.createElement('p');
      caja.className = 'zc__aviso';
      caja.setAttribute('data-zc-aviso', '');
      var pie = panel.querySelector('.zc__foot');
      if (pie) pie.insertBefore(caja, pie.firstChild); else panel.appendChild(caja);
    }
    caja.textContent = texto;
    caja.hidden = false;
    clearTimeout(caja._zcTimer);
    caja._zcTimer = setTimeout(function () { caja.hidden = true; }, 6000);
  }

  function mensajeDeError(respuesta) {
    return respuesta.json().then(function (d) {
      return (d && (d.description || d.message)) || 'No pudimos hacer el cambio.';
    }).catch(function () { return 'No pudimos hacer el cambio.'; });
  }

  function contenedor() {
    return document.getElementById('shopify-section-' + SECCION);
  }

  function abrir() {
    if (!contenedor()) return;
    document.body.classList.add('zc-open');
    var recs = document.querySelector('[data-zc-recs]');
    if (recs && recs.hidden && !recs.dataset.pedidas) {
      recs.dataset.pedidas = '1';
      cargarRecomendaciones();
    }
    var panel = document.querySelector('.zc__panel');
    if (panel) panel.setAttribute('tabindex', '-1'), panel.focus({ preventScroll: true });
  }

  function cerrar() {
    document.body.classList.remove('zc-open');
  }

  // Vuelve a pedirle a Shopify el HTML de la sección, ya con el carrito actualizado.
  function refrescar(abrirDespues) {
    if (refrescando) return Promise.resolve();
    refrescando = true;

    return fetch(raiz + '?sections=' + SECCION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECCION];
        var destino = contenedor();
        if (!html || !destino) return;

        var temporal = document.createElement('div');
        temporal.innerHTML = html;
        var nuevo = temporal.querySelector('#shopify-section-' + SECCION);
        destino.innerHTML = nuevo ? nuevo.innerHTML : temporal.innerHTML;

        sincronizarContadoresDelTema();
        cargarRecomendaciones();
        if (abrirDespues) abrir();
      })
      .catch(function () { /* si falla, el carrito sigue como estaba */ })
      .finally(function () { refrescando = false; });
  }

  // El header del tema tiene su propio contador: lo dejamos igualado.
  function sincronizarContadoresDelTema() {
    var burbuja = document.querySelector('.zc-bubble__count');
    if (!burbuja) return;
    var total = parseInt(burbuja.textContent.trim(), 10) || 0;
    document.querySelectorAll('.cart-count, [data-cart-count], .cart .count').forEach(function (el) {
      el.textContent = total;
    });
  }

  function cambiarCantidad(linea, cantidad) {
    var panel = document.querySelector('.zc__panel');
    if (panel) panel.style.opacity = '.55';

    return fetch(raiz + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad })
    })
      .then(function (r) {
        if (!r.ok) return mensajeDeError(r).then(avisar);
      })
      .then(function () { return refrescar(false); })
      .then(function () {
        var p = document.querySelector('.zc__panel');
        if (p) p.style.opacity = '';
      });
  }


  // Shopify no deja cambiarle la talla a una línea: toca meter la nueva y sacar la vieja.
  // Se saca por su clave, no por su número de línea, porque Shopify mete lo nuevo de
  // primeras y todas las líneas se corren.
  function cambiarTalla(clave, variante, cantidad) {
    var panel = document.querySelector('.zc__panel');
    if (panel) panel.style.opacity = '.55';
    enCambioDeTalla = true;

    function soltar() {
      enCambioDeTalla = false;
      var p = document.querySelector('.zc__panel');
      if (p) p.style.opacity = '';
    }

    return fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variante, quantity: cantidad })
    })
      .then(function (r) {
        // Si la talla nueva no tiene inventario, la vieja se queda donde está.
        if (!r.ok) {
          return mensajeDeError(r).then(function (texto) {
            return refrescar(false).then(function () { soltar(); avisar(texto); });
          });
        }
        return fetch(raiz + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: clave, quantity: 0 })
        })
          .then(function () { return refrescar(false); })
          .then(soltar);
      })
      .catch(function () { soltar(); avisar('No pudimos hacer el cambio.'); });
  }

  // --- Completa tu look ----------------------------------------------------
  // La regla, en orden:
  //   1. Los complementarios que Pilar puso en Search & Discovery para el último
  //      producto agregado.
  //   2. Lo que falte para llegar a tres se rellena con los más vendidos.
  //   3. Nunca entra algo que ya esté en el carrito, ni algo agotado (eso lo filtra
  //      la sección en Liquid), ni ropa de niña si el carrito es solo de mujer.
  function cargarRecomendaciones() {
    var caja = document.querySelector('[data-zc-recs]');
    if (!caja) return;

    var fila = caja.querySelector('[data-zc-recs-row]');
    var base = ultimoAgregado || caja.dataset.base;
    if (!fila || !base) return;

    var enCarrito = (caja.dataset.enCarrito || '').split(',').filter(Boolean);
    var limite = parseInt(caja.dataset.limite, 10) || 3;
    var hayKids = caja.dataset.hayKids === '1';
    var hayMujer = caja.dataset.hayMujer === '1';

    // Carrito solo de mujer no recibe ropa de niña, y al revés. Mezclado recibe las dos.
    function permitidoPorGenero(tarjeta) {
      var esKids = tarjeta.dataset.kids === '1';
      if (esKids && !hayKids && hayMujer) return false;
      if (!esKids && !hayMujer && hayKids) return false;
      return true;
    }

    function tarjetasDe(html) {
      var temporal = document.createElement('div');
      temporal.innerHTML = html;
      return [].slice.call(temporal.querySelectorAll('[data-zc-rec]'));
    }

    function pedir(url) {
      return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    }

    var urlComplementarios = raiz + 'recommendations/products?section_id=cart-recommendations' +
      '&product_id=' + encodeURIComponent(base) + '&intent=complementary&limit=10';
    // Si Pilar configuró la colección de tendencia, esa manda: son los de los últimos
    // 30 días. El "best-selling" de Shopify cuenta toda la historia de la tienda, así que
    // solo sirve de respaldo.
    var tendencia = caja.dataset.tendencia;
    var urlTendencia = tendencia
      ? raiz + 'collections/' + tendencia + '?section_id=cart-recommendations'
      : '';
    var urlMasVendidos = raiz + 'collections/all?sort_by=best-selling&section_id=cart-recommendations';

    function candidatosDe(html) {
      return tarjetasDe(html).filter(function (t) {
        return enCarrito.indexOf(t.dataset.productId) === -1 && permitidoPorGenero(t);
      });
    }

    var elegidas = [];
    var ids = [];

    function meter(lista) {
      lista.forEach(function (t) {
        if (elegidas.length >= limite) return;
        if (ids.indexOf(t.dataset.productId) !== -1) return;
        elegidas.push(t);
        ids.push(t.dataset.productId);
      });
    }

    // Carrito mixto: la regla es que se vean las dos cosas, no solo la del último
    // producto agregado. Si quedaron todas del mismo lado, la última cede el puesto.
    function mezclarSiHaceFalta(todos) {
      if (!(hayKids && hayMujer) || elegidas.length < 2) return;
      var hayDeNina = elegidas.some(function (t) { return t.dataset.kids === '1'; });
      var hayDeMujer = elegidas.some(function (t) { return t.dataset.kids !== '1'; });
      if (hayDeNina && hayDeMujer) return;

      var faltaKids = !hayDeNina;
      var reemplazo = todos.find(function (t) {
        var esKids = t.dataset.kids === '1';
        return esKids === faltaKids && ids.indexOf(t.dataset.productId) === -1;
      });
      if (!reemplazo) return;

      elegidas[elegidas.length - 1] = reemplazo;
      ids[ids.length - 1] = reemplazo.dataset.productId;
    }

    function pintar() {
      if (!elegidas.length) { caja.hidden = true; return; }
      if (!suerte) elegidas.forEach(function (t) { var e = t.querySelector('[data-zc-pct]'); if (e) e.remove(); });
      fila.innerHTML = '';
      elegidas.forEach(function (t) { fila.appendChild(t); });
      fila.scrollLeft = 0;
      caja.hidden = false;
    }

    var deComplementarios = [];
    // 7 días de suerte: primero lo que tiene descuento real y stock, de mayor a menor.
    var suerte = caja.dataset.suerte === '1';
    var urlSuerte = suerte ? raiz + 'collections/' + (caja.dataset.suerteColeccion || 'hot-trendy') + '?section_id=cart-recommendations' : '';
    function conDescuento(lista) {
      return lista.filter(function (t) { return parseInt(t.dataset.descuento, 10) > 0; })
        .sort(function (a, b) { return parseInt(b.dataset.descuento, 10) - parseInt(a.dataset.descuento, 10); });
    }

    Promise.all([pedir(urlComplementarios), urlSuerte ? pedir(urlSuerte) : ''])
      .then(function (r) {
        deComplementarios = candidatosDe(r[0]);
        if (suerte) {
          meter(conDescuento(deComplementarios));
          meter(conDescuento(r[1] ? candidatosDe(r[1]) : []));
        }
        meter(deComplementarios);
        // Los más vendidos se piden también cuando el carrito es mixto, porque de ahí
        // sale la prenda del lado que falte.
        var faltaRellenar = elegidas.length < limite && caja.dataset.rellenar !== '0';
        if (!faltaRellenar && !(hayKids && hayMujer)) return ['', ''];
        // Se piden las dos: si la de tendencia viene corta o vacía, entra el respaldo.
        return Promise.all([
          urlTendencia ? pedir(urlTendencia) : '',
          pedir(urlMasVendidos)
        ]);
      })
      .then(function (respuestas) {
        var deTendencia = respuestas[0] ? candidatosDe(respuestas[0]) : [];
        var deMasVendidos = respuestas[1] ? candidatosDe(respuestas[1]) : [];
        var respaldo = deTendencia.concat(deMasVendidos);
        if (caja.dataset.rellenar !== '0') meter(respaldo);
        mezclarSiHaceFalta(deComplementarios.concat(respaldo));
        pintar();
      });
  }

  // Los puntitos de las fotos siguen al deslizar.
  document.addEventListener('scroll', function (e) {
    var galeria = e.target.closest ? e.target.closest('[data-zc-gallery]') : null;
    if (!galeria) return;
    var puntos = galeria.parentElement.querySelectorAll('.zc-rec__dots span');
    if (!puntos.length) return;
    var actual = Math.round(galeria.scrollLeft / galeria.clientWidth);
    puntos.forEach(function (p, i) { p.classList.toggle('is-on', i === actual); });
  }, true);

  // --- Clicks dentro del carrito -------------------------------------------
  document.addEventListener('click', function (e) {
    var abre = e.target.closest('[data-zc-open]');
    if (abre) { e.preventDefault(); abrir(); return; }

    if (e.target.closest('[data-zc-close]')) { e.preventDefault(); cerrar(); return; }

    var qty = e.target.closest('[data-zc-qty]');
    if (qty) {
      e.preventDefault();
      cambiarCantidad(parseInt(qty.dataset.zcQty, 10), parseInt(qty.dataset.zcTo, 10));
      return;
    }

    var quitar = e.target.closest('[data-zc-remove]');
    if (quitar) {
      e.preventDefault();
      cambiarCantidad(parseInt(quitar.dataset.zcRemove, 10), 0);
      return;
    }

    var editar = e.target.closest('[data-zc-edit]');
    if (editar) {
      e.preventDefault();
      var panel = document.querySelector('[data-zc-swap="' + editar.dataset.zcEdit + '"]');
      if (panel) panel.hidden = !panel.hidden;
      return;
    }

    var cambiarA = e.target.closest('[data-zc-swap-to]');
    if (cambiarA && !cambiarA.disabled) {
      e.preventDefault();
      cambiarA.setAttribute('disabled', 'disabled');
      cambiarTalla(
        cambiarA.dataset.zcSwapKey,
        parseInt(cambiarA.dataset.zcSwapTo, 10),
        parseInt(cambiarA.dataset.zcSwapQty, 10) || 1
      );
      return;
    }

    var verTallas = e.target.closest('[data-zc-sizes]');
    if (verTallas) {
      e.preventDefault();
      var tallas = verTallas.parentElement.querySelector('.zc-rec__sizes');
      if (tallas) { tallas.hidden = !tallas.hidden; verTallas.hidden = !tallas.hidden; }
      return;
    }

    var agregar = e.target.closest('[data-zc-add]');
    if (agregar) {
      e.preventDefault();
      agregar.setAttribute('disabled', 'disabled');
      // El interceptor de /cart/add de más abajo se encarga de refrescar el carrito.
      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(agregar.dataset.zcAdd, 10), quantity: 1 })
      }).then(function (r) {
        if (r.ok) return; // el interceptor de más abajo refresca el carrito
        agregar.removeAttribute('disabled');
        return mensajeDeError(r).then(avisar);
      });
      return;
    }

    var pagar = e.target.closest('[data-zc-checkout]');
    if (pagar) {
      e.preventDefault();
      pagar.setAttribute('disabled', 'disabled');
      window.location = raiz + 'checkout';
      return;
    }

    // El ícono de carrito del header abre el lateral en vez de ir a la página.
    var enlaceCarrito = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (enlaceCarrito && !e.metaKey && !e.ctrlKey && contenedor()) {
      e.preventDefault();
      abrir();
    }
  });

  // Cantidad escrita a mano
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-zc-input]');
    if (!input) return;
    var cantidad = parseInt(input.value, 10);
    if (isNaN(cantidad) || cantidad < 0) cantidad = 1;
    cambiarCantidad(parseInt(input.dataset.zcInput, 10), cantidad);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('zc-open')) cerrar();
  });

  // --- Detectar cualquier "agregar al carrito" de la tienda ----------------
  // El tema agrega con jQuery (XHR) y algunas apps con fetch. Escuchamos las dos
  // vías para abrir el carrito sin tener que tocar cada botón.
  function esAgregar(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    var promesa = fetchOriginal.apply(this, arguments);
    if (esAgregar(url)) {
      promesa.then(function (r) {
        if (!r.ok || enCambioDeTalla) return;
        r.clone().json().then(function (item) {
          if (item && item.product_id) ultimoAgregado = String(item.product_id);
        }).catch(function () {}).then(function () { refrescar(true); });
      });
    }
    return promesa;
  };

  var abrirXHR = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this._zcEsAgregar = esAgregar(url);
    return abrirXHR.apply(this, arguments);
  };

  var enviarXHR = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._zcEsAgregar) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300 || enCambioDeTalla) return;
        try {
          var item = JSON.parse(this.responseText);
          if (item && item.product_id) ultimoAgregado = String(item.product_id);
        } catch (e) { /* si no viene JSON, se recomienda sobre el carrito */ }
        refrescar(true);
      });
    }
    return enviarXHR.apply(this, arguments);
  };
})();
